import { render, staticRenderFns } from "./CouponMore.vue?vue&type=template&id=7544cc0e&"
import script from "./CouponMore.vue?vue&type=script&lang=js&"
export * from "./CouponMore.vue?vue&type=script&lang=js&"
import style0 from "./CouponMore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports